import { Actions, ActionTypes } from './actions';
import { urgencyAdapter, initialState, UrgencyState } from './state';

export function urgencyReducer(state = initialState, action: Actions): UrgencyState {
  switch (action.type) {
    case ActionTypes.FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }
    case ActionTypes.LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_SUCCESS: {
      return urgencyAdapter.setAll(action.items, {
        ...state,
        isLoading: false,
        error: null,
      });
    }

    default: {
      return state;
    }
  }
}
